export function removeTrailingSlash(url) {
  return url.replace(/\/+$/, '');
}
